<template>
	<div>
		<div class="main-content-container container-fluid px-4"> 
			<div class="page-header row no-gutters py-4">
				<div class="col-12 col-sm-4 text-center text-sm-left mb-0">
				  <span class="text-uppercase page-subtitle">{{ this.$route.params.slug }}</span>
				  <h3 class="page-title">Editar</h3>
			  </div>
		   </div>
		   <div class="row">
	      <div class="col-lg-9 col-md-12">
	        <div class="card card-small mb-3">
	          <form type="POST" enctype="multipart/form-data">
	          <div class="card-body">
	              <div class="form-group">
	              	<input type="text" class="form-control" :class="error.name.status" placeholder="Nombre" v-model="form.name">
	              	<div class="invalid-feedback">
	              		<!-- ERROR MESSAGE HERE -->
	              	</div>
	              </div>
	              <div class="form-group">
	              	<input type="text" class="form-control" :class="error.lastname.status" placeholder="Apellido" v-model="form.lastname">
	              	<div class="invalid-feedback">
	              		<!-- ERROR MESSAGE HERE -->
	              	</div>
	              </div>
	              <div class="form-group">
	              	<input type="text" class="form-control" placeholder="Slug" v-model="slug" readonly>
	              </div>
	              <div class="form-group">
	              	<drag-and-drop
	                  message="Presiona o arrastra y suelta un archivo"
	                  @file="setFile"
	                  @base64="setBase64"
	                />
	                <div class="alert alert-danger" v-if="error.photo.message !== ''">
	                	<strong class="text-white">{{ error.photo.message[0] }}</strong>
	                </div>
	              </div>
	              <div class="form-group">
	              	<textarea rows="4" class="form-control" :class="error.message.status" placeholder="Mensaje" v-model="form.message"></textarea>
	              	<div class="invalid-feedback">
	              		<!-- ERROR MESSAGE HERE -->
	              	</div>
	              </div>
	          </div>
	          <div class="card-header border-top">
	          	<button type="submit" class="btn btn-primary" @click.prevent="updateTestimonial">
	          		Editar
	          	</button>
	          </div>
	          </form>
	        </div>
	      </div>
	      <div class="d-none d-md-inline-block col-lg-3 col-md-12">
	        <div class='card card-small mb-3'>
	          <div class="card-header border-bottom">
	            <h6 class="m-0">Vista previa</h6>
	          </div>
	          <div class='card-body p-2 d-flex justify-content-center'>
	            <i class="fas fa-images display-3 mt-4 mb-4 text-light" v-if="!photo.src"></i>
							<img id="preview" :src="photo.src"/>
	          </div>
	          <div class="card-footer" v-if="form.photo">
	          	<button class="btn btn-secondary" @click="deletePhoto">
	             <i class="fas fa-trash"></i> 
	            </button>
	          </div>
	        </div>
	      </div>
	     </div>
	   </div>
	</div>
</template>

<script>
	import DragAndDrop from '@/components/general/DragAndDrop.vue'
	export default {
		components: {
			'drag-and-drop': DragAndDrop
		},

		data() {
			return {
				testimonial: '',
				form: {
					name: '',
					lastname: '',
					photo: '',
					message: ''
				},
				photo: {
					src: ''
				},
				error: {
					name: {
						status: '',
						message: ''
					},
					lastname: {
						status: '',
						message: ''
					},
					photo: {
						status: '',
						message: ''
					},
					message: {
						status: '',
						message: ''
					}
				}
			}
		},

		computed: {
			slug: function(){
				return this.form.name.toLowerCase().split(' ').join('_')
			}
		},

		mounted() {
			this.getTestimonial();
		},

		methods: {
			async getTestimonial() {
				const url = `${process.env.VUE_APP_ROOT_API}/testimonial/${this.$route.params.slug}`;
				const response = await fetch(url);
				const data = await response.json();
				this.form.name = data.name;
				this.form.lastname = data.lastname;
				this.slug = data.slug;
				this.form.message = data.message;
				this.photo.src = data.photo;
			},

			setFile(data) {
				this.form.photo = data;
			},

			setBase64(data) {
				this.photo.src = data;
			},

			deletePhoto() {
				this.form.photo = '';
				this.photo.src = '';
			},

			updateTestimonial() {
				if(this.form.photo == '') {
					this.updatePartially();
				}else {
					this.updateAll();
				}
			},

			async updatePartially() {
				const url = `${process.env.VUE_APP_ROOT_API}/testimonial/partially/${this.$route.params.slug}`;
				const formData = new FormData();
				formData.append('user_id', this.$store.state.auth.user.id);
				formData.append('name', this.form.name);
				formData.append('lastname', this.form.lastname);
				formData.append('slug', this.slug);
				formData.append('message', this.form.message);
				const settings = {
					method: 'POST',
					body: formData
				};
				const response = await fetch(url, settings);
				const status = response.status;
				switch (status) {
					case 200:
						this.successMessage();
						break;
				}
			},

			async updateAll() {
				const url = `${process.env.VUE_APP_ROOT_API}/testimonial/${this.$route.params.slug}`;
				const formData = new FormData();
				formData.append('user_id', this.$store.state.auth.user.id);
				formData.append('name', this.form.name);
				formData.append('lastname', this.form.lastname);
				formData.append('slug', this.form.slug);
				formData.append('photo', this.form.photo);
				formData.append('message', this.form.message);
				const settings = {
					method: 'POST',
					body: formData
				};
				const response = await fetch(url, settings);
				const status = response.status;
				switch (status) {
					case 200:
						this.successMessage();
						break;
				}
			},

			successMessage() {
        this.$toasted.show("<i class='fas fa-quote-left'></i> Testimonio actualizado!", { 
           theme: "toasted-primary", 
           position: "top-right", 
           duration : 2000
        });
        this.$router.replace('/testimonios');
			}
		}
	}
</script>